module.exports = __webpack_public_path__ + "static/img/bsc.e59385ff.png";